export type PlanId = 'free' | 'lecteur' | 'collection';

export interface Plan {
  id: PlanId;
  name: string;
  price: string;
  period: string;
  annual?: string;
  description: string;
  cta: string;
  featured?: boolean;
  features: string[];
}

export const PLANS: Plan[] = [
  {
    id: 'free',
    name: 'Découverte',
    price: '0 €',
    period: 'pour toujours',
    description: 'Un premier emprunt, une seule fois, pour tester le parcours complet.',
    cta: 'Créer un compte',
    features: [
      '1 emprunt dans la vie du compte',
      'Dépôt illimité de vos livres',
      'Remise dans un lieu partenaire à Bruxelles',
      'Caution selon la valeur du livre',
      'Notation et historique',
    ],
  },
  {
    id: 'lecteur',
    name: 'Lecteur',
    price: '3,90 €',
    period: '/ mois',
    annual: '36 € / an',
    description: 'Pour lire régulièrement sans racheter, en complément de la bibliothèque publique.',
    cta: 'Rejoindre la liste',
    featured: true,
    features: [
      'Jusqu’à 2 livres en même temps',
      'Emprunts illimités dans l’année',
      'Protection BookShare jusqu’à 40 €',
      'Chat et créneaux partenaires',
      'Annulation à tout moment',
    ],
  },
  {
    id: 'collection',
    name: 'Collection',
    price: '6,90 €',
    period: '/ mois',
    annual: '69 € / an',
    description: 'Pour les ouvrages de valeur et les lecteurs qui prêtent autant qu’ils empruntent.',
    cta: 'Rejoindre la liste',
    features: [
      'Jusqu’à 4 livres en même temps',
      'Livres rares et de valeur',
      'Protection jusqu’à 200 €',
      'Priorité sur les créneaux partenaires',
      'Badge collection protégée',
    ],
  },
];
